// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import type { FormProps } from 'redux-form';
import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';

import type { Dispatch } from 'state/types';
import DialogPanel from 'view/App/DialogPanels/DialogPanel';
import { SET_ACCOUNT_PANEL_ID } from 'util/constants';
import localizedStrings from 'util/localizedStrings';
import LabeledField from 'view/Forms/LabeledField';
import { getExtensisAccount } from 'state/selectors';
import { setExtensisAccount } from 'state/commands/licenseCommands';
import { hideDialogPanel } from 'state/commands/dialogPanelCommands';
import { bindActionCreatorsSafe } from 'util/safeDispatch';

type Props = {
  activePanelId: ?string,
  extensisAccount: ?string,
  setExtensisAccount: typeof setExtensisAccount,
  hideDialogPanel: typeof hideDialogPanel,
  intl: IntlShape,
} & FormProps;

class SetAccountDialog extends Component<Props> {
  handleRemoveAccount: Function;
  handleSubmit: Function;
  isOkEnabled: Function;
  submit: Function;

  isOkEnabled() {
    return this.props.valid && !this.props.pristine;
  }

  submit(data: Object, props: Props) {
    this.handleSubmit(data.extensisAccount, data.extensisAccountPassword);
  }

  handleRemoveAccount() {
    this.handleSubmit('', '');
  }

  handleSubmit(account, password) {
    this.props.setExtensisAccount(account, password);
    this.props.hideDialogPanel();
  }

  constructor() {
    super();
    this.handleRemoveAccount = this.handleRemoveAccount.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.isOkEnabled = this.isOkEnabled.bind(this);
    this.submit = this.submit.bind(this);
  }

  render() {
    const {
      activePanelId,
      extensisAccount,
      handleSubmit,
      hideDialogPanel,
      intl: { formatMessage },
    } = this.props;
    return (
      <DialogPanel
        activePanelId={activePanelId}
        contentStyle={{ width: '600px', height: null }}
        customButtonText={formatMessage(localizedStrings.LIC_SET_ACCOUNT)}
        dialogFocusId="extensisAccount"
        hideDialogPanel={hideDialogPanel}
        isOkEnabled={this.isOkEnabled}
        lowerLeftButtonText={
          extensisAccount
            ? formatMessage(localizedStrings.LIC_REMOVE_ACCOUNT)
            : ''
        }
        onClickLowerLeftButton={
          extensisAccount ? this.handleRemoveAccount : () => {}
        }
        onSave={handleSubmit(this.submit)}
        panelId={SET_ACCOUNT_PANEL_ID}
        panelTitle={formatMessage(localizedStrings.LIC_SET_EXTENSIS_ACCOUNT)}
        showCancel
      >
        <form className="portfolio-form-container">
          <LabeledField label={formatMessage(localizedStrings.LIC_ACCOUNT)}>
            <Field
              autoComplete="extensis-account"
              className="input"
              component="input"
              data-test-name="account-name"
              id="extensisAccount"
              name="extensisAccount"
              type="text"
            />
          </LabeledField>
          <LabeledField label={formatMessage(localizedStrings.LIC_PASSWORD)}>
            <Field
              autoComplete="new-password"
              className="input"
              component="input"
              data-test-name="account-password"
              id="extensisAccountPassword"
              name="extensisAccountPassword"
              type="password"
            />
          </LabeledField>
        </form>
      </DialogPanel>
    );
  }
}

function validate(data) {
  const errors = {};
  if (!data.extensisAccount) {
    errors.extensisAccount = 'Required';
  }
  if (!data.extensisAccountPassword) {
    errors.extensisAccountPassword = 'Required';
  }
  return errors;
}

const form = reduxForm({
  form: SET_ACCOUNT_PANEL_ID,
  validate,
})(SetAccountDialog);

export default connect(
  state => ({
    extensisAccount: getExtensisAccount(state),
    initialValues: { extensisAccount: getExtensisAccount(state) },
  }),
  (dispatch: Dispatch) =>
    bindActionCreatorsSafe({
      hideDialogPanel,
      setExtensisAccount,
    })
)(injectIntl(form));



// WEBPACK FOOTER //
// ./src/view/Pages/LicensesPage/SetAccountDialog.js